export default {
    backColor: '#f5fbfa',
    darkGreen: '#32A08C',
    darkBlue: '#1e2e46',
    buttonGreen: '#e3efe9',
};